export const Logo = ({ size = 34 }) => (
  <span className="flex items-center gap-2.5 select-none">
    <img
      src="/images/hadron-mark.png"
      alt=""
      width={size}
      height={size}
      className="object-contain shrink-0"
      aria-hidden="true"
    />
    <span className="font-display font-bold lowercase leading-none tracking-wide text-lg sm:text-xl">
      <span className="text-hadron-green">hadron</span>{" "}
      <span className="text-hadron-cyan">energy</span>
    </span>
  </span>
);
